import * as React from "react"

import TitleHero from "./TitleHero";
import { Link } from "react-scroll";

export default function Hero({ heroObj }) {
    return (
        <section id="hero" className="section_hero">
            <div className="padding-global">
                <div
                    data-aos='fade-in'
                    data-aos-duration='500'
                    className="container-hero">
                    <TitleHero contentObj={heroObj} />
                    <video
                        data-aos='fade-in'
                        data-aos-duration='500'
                        className="videoTag"
                        poster={'/assets/images/common/poster.webp'}
                        autoPlay
                        loop
                        muted
                        playsInline>
                        <source
                            src="/assets/images/common/Hero_Video_2023_New.mp4"
                            type="video/mp4"
                            width="auto"
                            height="auto"
                            title="Changex wallet video "
                        />
                    </video>
                    <div
                        className="hero_text-wrapper">
                        <a href="https://cointelegraph.com/news/web3s-swiss-army-knife-of-personal-finance-changex-joins-cointelegraph-accelerator" >
                            <img
                                src="/assets/images/press/cointelegraph-logo.svg"
                                loading="lazy"
                                width="75"
                                height="50"
                                alt="Changex QR code"
                                className="qr-small-cta"
                            ></img>
                        </a>
                    </div>
                </div>
            </div>
        </section >
    );
}
